module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/tools/hummer-223d2ae52685170bfc4e711fadb0616d.svg";